import { render, staticRenderFns } from "./AppStep21.vue?vue&type=template&id=4ab49e2c"
import script from "./AppStep21.vue?vue&type=script&lang=js"
export * from "./AppStep21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports